// a little function to help us with reordering the result
export function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}
export const valueFromString = (value, size) => {
    // @ts-ignore
    if (value === "auto")
        return "auto";
    if (value === "")
        return 0;
    if (typeof value === "number")
        return value;
    if (value.endsWith("%")) {
        return (parseFloat(value.substring(0, value.length - 1)) * size) / 100;
    }
    else if (value.endsWith("px")) {
        return parseFloat(value.substring(0, value.length - 2));
    }
    return parseFloat(value);
};
export const valueToString = (value, size) => {
    if (size === 0) {
        return "0%";
    }
    return `${Math.round((value / size) * 100)}%`;
};
export const duplicateItemCoordinates = ({ x, y, }) => {
    let newX = x;
    let newY = y;
    if (x.endsWith("%")) {
        newX = `${parseFloat(x) + 2}%`;
    }
    else if (x.endsWith("px")) {
        newX = `${parseFloat(x.substring(0, x.length - 2)) + 20}px`;
    }
    else {
        newX = x + 20;
    }
    if (y.endsWith("%")) {
        newY = `${parseFloat(y) + 2}%`;
    }
    else if (y.endsWith("px")) {
        newY = `${parseFloat(y.substring(0, y.length - 2)) + 20}px`;
    }
    else {
        newY = y + 20;
    }
    return {
        x: newX,
        y: newY,
    };
};
export const widgetsWithAnimations = ["text", "clock"];
